export default __webpack_public_path__ + "static/bed-bath-beyond-3-aa-2052d3e0dc2f183aba3b15925060a3c7.webp";